import React from "react";
import Cookies from "universal-cookie";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import addClient from "../../services/addClient";
import createNewDatabase from "../../services/createNewDatabase";
import FixButton from "../../widgets/Button";
import ImageInput from "../../widgets/ImageInput";
import TextInput from "../../widgets/TextInput";
import LoadingOverlay from 'react-loading-overlay';

export default class AddClient extends React.Component {

  constructor(props){
    super (props)

    this.state = {
        clientName: '', 
        clientAddress: '', 
        clientCity: '',
        clientProvince: '', 
        clientCAP: '', 
        clientEmail: '', 
        clientTelefono: '', 
        clientLogo: '', 
        display: 'flex',
        marginLeft: '50px',
        adminUser: '', 
        billingUser: '', 
        adminPass: '', 
        billingPass: '',
        isLoading: false
    }
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    if (window.innerWidth < 960) {
      this.setState({ display: '', marginLeft: '' });
    } else {
      this.setState({ display: 'flex', marginLeft: '50px' });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  async handleSave() {

      if (this.state.clientEmail && !(/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.clientEmail))) {
        alert("Verifica la mail inserita.");
        return;
      }

      if (this.state.clientName != '' && this.state.billingUser != '' && this.state.billingPass != '' && this.state.adminUser != '' && this.state.adminPass != '') {
          
          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          this.dbName = this.state.clientName.toLowerCase().split(' ').join('');
          this.dbName = this.dbName.split('.').join('_');
          this.dbName += this.getRandomInt(1000);

          this.setState({ isLoading: true });

          await createNewDatabase(username, token, this.state.clientName, this.state.clientLogo, this.dbName, this.state.adminUser, this.state.adminPass, this.state.billingUser, this.state.billingPass);

          this.client = await addClient(
            username, 
            token,
            this.state.clientName, 
            this.state.clientAddress, 
            this.state.clientCity, 
            this.state.clientProvince, 
            this.state.clientCAP, 
            this.state.clientEmail, 
            this.state.clientTelefono, 
            this.state.clientLogo, 
            this.dbName
          );
          
          if (this.client.result == 'ok') {
              alert('Cliente creato con successo');
              window.location.href = '/admin#/admin/clients';
          }
    } else {
      alert("Verifica di aver inserito il nome del cliente e le sue credenziali predefinite.");
    }
  }

  render () {

    return (
      <div>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px', 
          zIndex: 999
        })
      }}
      spinner
      text={'Attendi...'}
      >
        <PageTitle title="Nuovo cliente" />
        
        <div style={{display: this.state.display}}>
            <div style={{flex: 1, maxWidth: '300px'}}>
                <TextInput name={'Ragione sociale'} value={this.state.clientName} 
                  onChange={(val) => 
                      this.setState({ clientName: val })
                  }
                />

                <p style={{marginLeft: 6, marginTop: 37}}><b>Contatti</b></p>
                <TextInput name={'Mail'} value={this.state.clientEmail} 
                  onChange={(val) => 
                    this.setState({ clientEmail: val })
                }/> 

                <TextInput name={'Telefono'} value={this.state.clientTelefono} 
                  onChange={(val) => 
                    this.setState({ clientTelefono: val })
                }/> 
            </div>

            <div style={{flex: 1, maxWidth: '300px', marginLeft: this.state.marginLeft}}>
                <TextInput name={'Indirizzo'} value={this.state.clientAddress} 
                  onChange={(val) => 
                    this.setState({ clientAddress: val })
                }/> 

                <TextInput name={'Città'} value={this.state.clientCity} 
                  onChange={(val) => 
                    this.setState({ clientCity: val })
                }/> 

                <TextInput name={'Provincia'} value={this.state.clientProvince} 
                  onChange={(val) => 
                    this.setState({ clientProvince: val })
                }/> 

                <TextInput name={'CAP'} value={this.state.clientCAP} 
                  onChange={(val) => 
                    this.setState({ clientCAP: val })
                }/> 
            </div>
        </div>
        <br/>
        <br/>
        <ImageInput name={'Logo'} key={Math.random()} 
            value={this.state.clientLogo}
            onChange={(val) =>           
              this.setState({ clientLogo: val })
            }
          />

          <PageTitle title="Credenziali" />
          <div style={{display: this.state.display}}>
              <div style={{flex: 1, maxWidth: '300px'}}>
                  <TextInput name={'Nome utente admin'} value={this.state.adminUser} 
                      onChange={(val) => 
                        this.setState({ adminUser: val })
                  }/> 

                  <TextInput name={'Password admin'} value={this.state.adminPass} 
                    onChange={(val) => 
                      this.setState({ adminPass: val })
                  }/> 
              </div>

              <div style={{flex: 1, maxWidth: '300px', marginLeft: this.state.marginLeft}}>
                  <TextInput name={'Nome utente billing'} value={this.state.billingUser} 
                      onChange={(val) => 
                        this.setState({ billingUser: val })
                  }/> 

                  <TextInput name={'Password billing'} value={this.state.billingPass} 
                    onChange={(val) => 
                      this.setState({ billingPass: val })
                  }/> 
              </div>
          </div>
          <br/>
          <FixButton title={'Salva'} callback={() => this.handleSave()} />
          <br/><br/><br/><br/>
          </LoadingOverlay>
      </div>
    );
  }

}

